import React, { Component } from 'react'
import Link from 'gatsby-link'
import {Title} from '../Title'
import {InfoBlockGrid} from '../InfoBlockGrid'

import './featured-artists.css'

const nArtistsPerRow = 3;
const nArtistsPerRowMobile = 1;

class FeaturedArtists extends Component {

  render () {
    let data = this.props.data;

    return (
      <div>
        <Title name={data.title}></Title>
        <InfoBlockGrid
          nCellsPerRow = {nArtistsPerRow}
          nCellsPerRowMobile = {nArtistsPerRowMobile}
          data = {data.artists}
          sizes = {this.props.sizes}>
        </InfoBlockGrid>
      </div>
    );
  }
}


export default {FeaturedArtists}



// WEBPACK FOOTER //
// ./src/components/FeaturedArtists/index.js